module.exports = __webpack_public_path__ + "img/IMG_8990.cc7eee36.jpg";